import { createFileRoute } from '@tanstack/react-router'

import { NoteDetailPage } from '@/components/organisms/notes/note-detail-page'

/**
 * A note read from the notes list. The errand-scoped twin at /errands/$id/notes/$noteId renders
 * the same page — see note-detail-page.tsx.
 */
const NoteRoute = () => {
  const { noteId } = Route.useParams()

  return <NoteDetailPage noteId={noteId} />
}

export const Route = createFileRoute('/_authenticated/notes/$noteId')({
  component: NoteRoute,
})
